
(function(){
'use strict';
if(window.__cappyrootsGiftRuntime)return;
// The integrated cart runtime owns gift reconciliation on the current theme. Defer to it instead of
// registering a second delayed reconciler that can overwrite the refreshed drawer or remove its guide.
if(document.querySelector('script[src*="cappyroots-cart-runtime.js"]')){window.__cappyrootsGiftRuntime=true;return;}
window.__cappyrootsGiftRuntime=true;
var d=document;
var drawer=d.getElementById('CrCartDrawer');
var reconcileTimer=null;
function crFetchCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(response){if(!response.ok){throw new Error('cart fetch failed');}return response.json();});}
function crConfiguredGiftForItem(item){
  var content=drawer&&drawer.querySelector('[data-cr-drawer-content]');
  var autoGuideBundle=content&&content.getAttribute('data-cr-bundle-variant');
  if(autoGuideBundle&&String(item.variant_id)===String(autoGuideBundle)){return 0;}
  var properties=item.properties||{};
  var direct=Number(properties._cappyroots_gift_variant)||0;
  if(direct)return direct;
  var mapped=d.querySelector('[data-cr-cart-parent-variant="'+String(item.variant_id)+'"]');
  return mapped?Number(mapped.getAttribute('data-cr-cart-parent-gift'))||0:0;
}
function syncFreeGiftLines(){
  return crFetchCart().then(function(cart){
    var required={};var parentFor={};
    cart.items.forEach(function(item){
      var properties=item.properties||{};
      if(String(properties._cappyroots_free_gift)==='true')return;
      var giftId=crConfiguredGiftForItem(item);
      if(giftId&&item.quantity>0){required[String(giftId)]=true;parentFor[String(giftId)]=item.variant_id;}
    });
    var seen={};var updates={};
    cart.items.forEach(function(item){
      var properties=item.properties||{};
      if(String(properties._cappyroots_free_gift)!=='true')return;
      var giftKey=String(item.variant_id);
      if(!required[giftKey]||seen[giftKey]){updates[item.key]=0;return;}
      seen[giftKey]=true;
      if(item.quantity!==1){updates[item.key]=1;}
    });
    var changed=Object.keys(updates).length>0;
    var afterUpdates=changed?fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})}).then(function(response){if(!response.ok){throw new Error('gift update failed');}return response.json();}):Promise.resolve(cart);
    return afterUpdates.then(function(nextCart){
      var present={};
      nextCart.items.forEach(function(item){var properties=item.properties||{};if(String(properties._cappyroots_free_gift)==='true'&&item.quantity>0){present[String(item.variant_id)]=true;}});
      var additions=[];
      Object.keys(required).forEach(function(giftId){if(!present[giftId]){additions.push({id:Number(giftId),quantity:1,properties:{_cappyroots_free_gift:'true',_cappyroots_gift_for:String(parentFor[giftId])}});}});
      if(!additions.length){return {cart:nextCart,changed:changed};}
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:additions})})
        .then(function(response){if(!response.ok){throw new Error('gift add failed');}return response.json();})
        .then(crFetchCart)
        .then(function(addedCart){return {cart:addedCart,changed:true};});
    });
  });
}
function crRefreshDrawer(latestItemCount){
  drawer=d.getElementById('CrCartDrawer');
  var wrapper=drawer&&drawer.closest('.shopify-section');
  var sectionId=wrapper?wrapper.id.replace(/^shopify-section-/,''):'cappyroots-cart-drawer';
  return fetch(window.location.pathname+'?sections='+encodeURIComponent(sectionId))
    .then(function(response){return response.json();})
    .then(function(sections){
      var markup=sections[sectionId];
      if(markup&&drawer){
        var parsed=new DOMParser().parseFromString(markup,'text/html');
        var fresh=parsed.querySelector('[data-cr-drawer-content]');
        var current=drawer.querySelector('[data-cr-drawer-content]');
        if(fresh&&current){current.innerHTML=fresh.innerHTML;}
        var freshBadge=parsed.querySelector('.cr-iconbtn__count[data-cr-cart-count]');
        var value=freshBadge?(freshBadge.textContent||'').trim():null;
        if(value===null&&typeof latestItemCount==='number'){value=String(latestItemCount);}
        if(value!==null){d.querySelectorAll('.cr-iconbtn__count[data-cr-cart-count]').forEach(function(node){node.textContent=value;node.hidden=value===''||value==='0';});}
      }
    });
}
function refreshDrawerWithGiftSync(latestItemCount){return syncFreeGiftLines().then(function(result){var count=result.cart&&typeof result.cart.item_count==='number'?result.cart.item_count:latestItemCount;return crRefreshDrawer(count);});}
/* gift-item-builder:start */
function crBuildGiftAddItems(variantId,quantity,giftId){
  var parentItem={id:variantId,quantity:quantity};
  var giftItem=null;
  if(giftId){parentItem.properties={_cappyroots_gift_variant:String(giftId)};giftItem={id:giftId,quantity:1,properties:{_cappyroots_free_gift:'true',_cappyroots_gift_for:String(variantId)}};}
  return {items:giftItem?[parentItem,giftItem]:[parentItem]};
}
/* gift-item-builder:end */
/* gift-post-add:start */
function crGiftRefreshDeadline(){return new Promise(function(resolve){window.setTimeout(resolve,1800);});}
function crFinalizeGiftAdd(cart,refreshFn,onReady,waitForRefresh){
  var refresh=Promise.resolve().then(function(){return refreshFn(cart&&cart.item_count);}).catch(function(){});
  var deadline=waitForRefresh?waitForRefresh():null;
  return (deadline?Promise.race([refresh,deadline]):refresh).then(function(){try{if(onReady){onReady();}}catch(e){}});
}
/* gift-post-add:end */
/* gift-open-drawer:start */
function crOpenDrawer(){
  drawer=d.getElementById('CrCartDrawer');
  if(drawer&&typeof drawer.showModal==='function'&&!drawer.open){drawer.showModal();}
}
/* gift-open-drawer:end */
/* gift-submit:start */
function crSetGiftError(productForm,message){
  var errorNode=productForm.querySelector('[data-cr-gift-error]');
  if(!errorNode)return;
  errorNode.textContent=message||'';
  errorNode.hidden=!message;
}
function crSubmitGiftProduct(productForm,deps){
  var button=productForm.querySelector('[type="submit"]');
  var previous=button?button.textContent:'';
  crSetGiftError(productForm,'');
  if(button){button.disabled=true;button.textContent='Adding…';}
  var formData=new deps.FormDataCtor(productForm);
  var chosenQty=Number(formData.get('quantity'))||1;
  var selectedVariant=productForm.querySelector('[name="id"]:checked');
  var giftId=selectedVariant?Number(selectedVariant.getAttribute('data-cr-gift-variant'))||0:0;
  var addPayload=crBuildGiftAddItems(formData.get('id'),chosenQty,giftId);
  return deps.fetchFn('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(addPayload)})
    .then(function(response){if(!response.ok){throw new Error('add failed');}return response.json();})
    .then(function(cart){return crFinalizeGiftAdd(cart,deps.refreshFn,deps.openFn,deps.waitForRefresh);})
    .catch(function(){crSetGiftError(productForm,'We couldn’t update your cart. Please try again.');})
    .finally(function(){if(button){button.disabled=false;button.textContent=previous;}});
}
/* gift-submit:end */
function syncVariantGiftCard(radio){
  var giftPanel=d.querySelector('[data-cr-variant-gift]');
  if(!giftPanel||!radio)return;
  var giftId=radio.getAttribute('data-cr-gift-variant')||'';
  giftPanel.hidden=!giftId;
  var parentGiftField=d.querySelector('[data-cr-parent-gift]');
  if(parentGiftField){parentGiftField.value=giftId;parentGiftField.disabled=!giftId;}
  if(!giftId)return;
  var titleNode=giftPanel.querySelector('[data-cr-gift-title]');
  var valueNode=giftPanel.querySelector('[data-cr-gift-value]');
  var imageNode=giftPanel.querySelector('[data-cr-gift-image]');
  var giftTitle=radio.getAttribute('data-cr-gift-title')||'';
  var giftValue=radio.getAttribute('data-cr-gift-value')||'';
  var giftImage=radio.getAttribute('data-cr-gift-image')||'';
  if(titleNode){titleNode.textContent=giftTitle;}
  if(valueNode){valueNode.textContent=giftValue;valueNode.hidden=!giftValue;}
  if(imageNode){if(giftImage){imageNode.src=giftImage;imageNode.alt=radio.getAttribute('data-cr-gift-image-alt')||giftTitle;imageNode.hidden=false;}else{imageNode.removeAttribute('src');imageNode.alt='';imageNode.hidden=true;}}
}
function crScheduleReconcile(){if(reconcileTimer){window.clearTimeout(reconcileTimer);}reconcileTimer=window.setTimeout(function(){refreshDrawerWithGiftSync().catch(function(){});},900);}
d.addEventListener('change',function(event){var radio=event.target.closest('[data-cr-variant-price]');if(radio){syncVariantGiftCard(radio);}},true);
d.addEventListener('submit',function(event){
  var productForm=event.target.closest('[data-cr-product-form]');
  if(!productForm)return;
  if(productForm.getAttribute('data-cr-auto-guide-variant'))return;
  event.preventDefault();event.stopImmediatePropagation();
  crSubmitGiftProduct(productForm,{FormDataCtor:FormData,fetchFn:fetch,refreshFn:refreshDrawerWithGiftSync,openFn:crOpenDrawer,waitForRefresh:crGiftRefreshDeadline});
},true);
d.addEventListener('click',function(event){
  var addBtn=event.target.closest('[data-cr-cart-add]');
  if(addBtn){
    event.preventDefault();event.stopImmediatePropagation();
    var variantId=addBtn.getAttribute('data-cr-cart-add');
    if(!variantId)return;
    var previous=addBtn.textContent;addBtn.disabled=true;addBtn.textContent='Adding…';
    var giftId=Number(addBtn.getAttribute('data-cr-cart-gift'))||0;
    var payload=crBuildGiftAddItems(variantId,1,giftId);
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
      .then(function(response){if(!response.ok){throw new Error('add failed');}return response.json();})
      .then(function(cart){return crFinalizeGiftAdd(cart,refreshDrawerWithGiftSync,null,crGiftRefreshDeadline);})
      .catch(function(){var form=d.querySelector('[data-cr-product-form]');if(form){crSetGiftError(form,'We couldn’t update your cart. Please try again.');}})
      .finally(function(){addBtn.disabled=false;addBtn.textContent=previous;});
    return;
  }
  if(event.target.closest('#CrCartDrawer [data-cr-qty],#CrCartDrawer [data-cr-bundle-qty]')){crScheduleReconcile();}
},true);
function crInitVariantGift(){
  var selected=d.querySelector('[data-cr-variant-price]:checked');
  if(selected){syncVariantGiftCard(selected);}
  if(d.querySelector('[data-cr-product-form],[data-cr-cart-parent-gift],[data-cr-cart-free-gift]')){syncFreeGiftLines().then(function(result){if(result.changed){return crRefreshDrawer(result.cart.item_count);}}).catch(function(){});}
}
if(d.readyState==='loading'){d.addEventListener('DOMContentLoaded',crInitVariantGift);}else{crInitVariantGift();}
})();
